/**
 * useAuth Hook
 * Re-export from AuthContext for convenience
 */

import { useAuth, AUTH_STATUS } from '../context/AuthContext';

export { useAuth, AUTH_STATUS };
export default useAuth;
